var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafe = function SvgSafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#778091",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.899 13.417A7.002 7.002 0 0 1 17.5 8.75h28a7.003 7.003 0 0 1 6.757 5.165l2.96-1.48A1.75 1.75 0 0 1 57.75 14v35a1.75 1.75 0 0 1-2.533 1.565l-3.54-1.77A6.999 6.999 0 0 1 45.5 52.5a1.75 1.75 0 0 1-1.75 1.75H42a1.75 1.75 0 0 1-1.75-1.75h-17.5A1.75 1.75 0 0 1 21 54.25h-1.75a1.75 1.75 0 0 1-1.75-1.75 7.002 7.002 0 0 1-6.601-4.667 1.75 1.75 0 1 1 3.3-1.166A3.502 3.502 0 0 0 17.5 49h28a3.499 3.499 0 0 0 3.044-1.771l-.327-.164a1.75 1.75 0 0 1-.967-1.565v-28c0-.663.374-1.269.967-1.565l.777-.389A3.5 3.5 0 0 0 45.5 12.25h-28c-1.521 0-2.82.971-3.301 2.333a1.75 1.75 0 1 1-3.3-1.166ZM50.75 44.418V18.582l3.5-1.75v29.336l-3.5-1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 30.625a6.125 6.125 0 1 0-12.25 0 6.125 6.125 0 0 0 12.25 0ZM23.625 28a2.625 2.625 0 1 1 0 5.25 2.625 2.625 0 0 1 0-5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5 19.25a3.5 3.5 0 0 1 3.5 3.5V38.5a3.5 3.5 0 0 1-3.5 3.5H8.75a3.5 3.5 0 0 1-3.5-3.5V22.75a3.5 3.5 0 0 1 3.5-3.5H38.5Zm0 3.5V38.5H8.75V22.75H38.5Z"
  }))));
};
export default SvgSafe;